import {FC} from 'react'
import {codelessUnitRowNumbers, describeCodelessUnitRows} from '../../core/invoiceUnitCode'

type Props = {
  items: {unit?: {label?: unknown} | null}[]
}

/** Above the rows: the rows whose unit has no official code go out without mu. A warning only, never a stop. */
const CodelessUnitRowsNotice: FC<Props> = ({items}) => {
  const message = describeCodelessUnitRows(codelessUnitRowNumbers(items))
  if (!message) return null

  return (
    <div className='alert alert-warning d-flex align-items-start gap-2 p-4 mb-4' role='status'>
      <i className='las la-exclamation-triangle fs-2 mt-1' aria-hidden='true'></i>
      <div>{message}</div>
    </div>
  )
}

export {CodelessUnitRowsNotice}
